import {
    SET_USERS_DATA_LOADING,
    SET_USERS,
    SET_SEARCH_USERS,
    SET_SEARCH_USER_BY_ID,
} from "../actions/types";

const initialState = {
    isLoading: false,
    usersData: [],
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        limit: 10,
        hasNextPage: false,
        hasPrevPage: false,
        nextPage: null,
        prevPage: null,
    },
    searchedUsers: [],
    searchedUserById: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_USERS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload !== undefined ? payload : true,
            };
        case SET_USERS:
            return {
                ...state,
                usersData: payload.data,
                pagination: payload.pagination,
                isLoading: false,
            };
        case SET_SEARCH_USERS:
            return {
                ...state,
                searchedUsers: payload,
            };
        case SET_SEARCH_USER_BY_ID:
            return {
                ...state,
                searchedUserById: payload,
            };
        default:
            return state;
    }
}

